import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BuscadorSolicitudListComponent } from './solicitudes/buscador-solicitud-list.component';
import { BuscadorProductoListComponent } from './productos/buscador-producto-list.component';
import { EnumCodigosTwTcAcciones } from '../solicitudes/types/enum';
import { LoginGuard, ActionGuard } from '../../core/_infrastructure/classes/guards/main.guard';
import { RechazosTracesWrapperComponent } from './rechazostraces/rechazostraces-wrapper/rechazostraces-wrapper.component';
import { RechazosTracesWrapperParteIComponent } from './rechazostraces/rechazostraces-wrapper-parte-i/rechazostraces-wrapper-parte-i.component';
import { RechazosTracesWrapperParteIIComponent } from './rechazostraces/rechazostraces-wrapper-parte-ii/rechazostraces-wrapper-parte-ii.component';
import { RechazosTracesWrapperNoCumplimientoComponent } from './rechazostraces/rechazostraces-wrapper-no-cumplimiento/rechazostraces-wrapper-no-cumplimiento.component';

const buscadoresRoutes: Routes = [
    //SOLICITUDES
    {
        path: 'importacion/solicitudes',
        data: {
            breadcrumb: 'Solicitudes',
            menu0: 'IMPORTACIÓN', //,
            //menu1: 'Buscadores'
        },

        children: [
            {
                path: '',
                component: BuscadorSolicitudListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.SOLICITUD,
                },
            },
        ],
    },
    //PRODUCTOS
    {
        path: 'importacion/productos',
        data: {
            breadcrumb: 'Productos',
            menu0: 'IMPORTACIÓN', //,
            //menu1: 'Buscadores'
        },

        children: [
            {
                path: '',
                component: BuscadorProductoListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.SOLICITUD,
                },
            },
        ],
    },
    //RECHAZOS DE TRACES
    {
        path: 'importacion/rechazostraces',
        data: {
            breadcrumb: 'Rechazos de TRACES',
            menu0: 'IMPORTACIÓN', //,
            //menu1: 'Buscadores'
        },

        children: [
            {
                path: '',
                component: RechazosTracesWrapperComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MENU_RECHAZOS_TRACES,
                    isRechazo: true,
                },
            },
        ],
    },
    {
        path: 'importacion/rechazostraces',
        data: {
            breadcrumb: 'Rechazos de TRACES',
            menu0: 'IMPORTACIÓN', //,
            //menu1: 'Buscadores'
            actionCode: EnumCodigosTwTcAcciones.MENU_RECHAZOS_TRACES,
            isRechazo: true,
        },

        children: [
            {
                path: 'partei/:CHEDPP',
                component: RechazosTracesWrapperParteIComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Parte I',
                    actionCode: EnumCodigosTwTcAcciones.MENU_RECHAZOS_TRACES,
                    isRechazo: true,
                },
            },
            {
                path: 'parteii/:CHEDPP',
                component: RechazosTracesWrapperParteIIComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Parte II',
                    actionCode: EnumCodigosTwTcAcciones.MENU_RECHAZOS_TRACES,
                    isRechazo: true,
                },
            },
            {
                path: 'nocumplimiento/:CHEDPP',
                component: RechazosTracesWrapperNoCumplimientoComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'No cumplimiento',
                    actionCode: EnumCodigosTwTcAcciones.MENU_RECHAZOS_TRACES,
                    isRechazo: true,
                },
            },
        ],
    },
    //TRASLADOS DE TRACES
    {
        path: 'importacion/trasladostraces',
        data: {
            breadcrumb: 'Traslados de TRACES',
            menu0: 'IMPORTACIÓN', //,
            //menu1: 'Buscadores'
        },

        children: [
            {
                path: '',
                component: RechazosTracesWrapperComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MENU_TRASLADOS_TRACES,
                    isRechazo: false,
                },
            },
        ],
    },
    {
        path: 'importacion/trasladostraces',
        data: {
            breadcrumb: 'Traslados de TRACES',
            menu0: 'IMPORTACIÓN', //,
            //menu1: 'Buscadores'
            actionCode: EnumCodigosTwTcAcciones.MENU_TRASLADOS_TRACES,
            isRechazo: false,
        },

        children: [
            {
                path: 'partei/:CHEDPP',
                component: RechazosTracesWrapperParteIComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Parte I',
                    actionCode: EnumCodigosTwTcAcciones.MENU_TRASLADOS_TRACES,
                    isRechazo: false,
                },
            },
            {
                path: 'parteii/:CHEDPP',
                component: RechazosTracesWrapperParteIIComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Parte II',
                    actionCode: EnumCodigosTwTcAcciones.MENU_TRASLADOS_TRACES,
                    isRechazo: false,
                },
            },
        ],
    },
];
@NgModule({
    imports: [RouterModule.forChild(buscadoresRoutes)],
    exports: [RouterModule],
})
export class BuscadoresRoutingModule {}
